export default __webpack_public_path__ + "static/media/menu-selector.16cfbfde.svg";